import React from 'react';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import EditorParagraph from '@wix/da-ds/pkg/Icons/24x24/EditorParagraph';
import EditorH2 from '@wix/da-ds/pkg/Icons/24x24/EditorH2';
import EditorH3 from '@wix/da-ds/pkg/Icons/24x24/EditorH3';
import EditorH4 from '@wix/da-ds/pkg/Icons/24x24/EditorH4';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../_partials/EditorIconButtonWithContextMenu';

const BlockFormatting: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'heading'))
  ) {
    return null;
  }

  return (
    <EditorIconButtonWithContextMenu
      featureId="format:block"
      tooltipText={t('button.blockFormat.tooltip')}
      aria-label={t('button.blockFormat.tooltip')}
      icon={EditorParagraph}
      items={[
        {
          featureId: 'format:paragraph',
          label: t('button.blockFormat.paragraph'),
          IconComponent: EditorParagraph,
          isActive: editor.isActive('paragraph'),
          onClick: () => {
            editor.chain().focus().setParagraph().run();
          },
        },
        {
          featureId: 'format:h2',
          label: t('button.blockFormat.h2'),
          IconComponent: EditorH2,
          isActive: editor.isActive('heading', { level: 2 }),
          onClick: () => {
            editor.chain().focus().toggleHeading({ level: 2 }).run();
          },
        },
        {
          featureId: 'format:h3',
          label: t('button.blockFormat.h3'),
          IconComponent: EditorH3,
          isActive: editor.isActive('heading', { level: 3 }),
          onClick: () => {
            editor.chain().focus().toggleHeading({ level: 3 }).run();
          },
        },
        {
          featureId: 'format:h4',
          label: t('button.blockFormat.h4'),
          IconComponent: EditorH4,
          isActive: editor.isActive('heading', { level: 4 }),
          onClick: () => {
            editor.chain().focus().toggleHeading({ level: 4 }).run();
          },
        },
      ]}
    />
  );
};
BlockFormatting.displayName = 'BlockFormatting';

export default BlockFormatting;
